import React from 'react';
import {Backdrop, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, IconButton} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import SearchIcon from "@material-ui/icons/Search.js";
import LibraryContainer from "../LibraryContainer/LibraryContainer.jsx";
import {makeStyles} from "@material-ui/styles";
import {useSelector} from "react-redux";
import {getProjects} from "../../redux/reducers/project-reducer.js";
import {useDialog} from "../../hooks/useDialog.js";
import {selectLoading} from "../../redux/reducers/library-reducer.js";
import CloseIcon from "@material-ui/icons/Close.js";

const useStyles = makeStyles((theme) => ({
    header: {
        paddingBottom: theme.spacing(1)
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    dialogRoot: {
        '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0,0,0,0)'
        }
    },
    closeButton: {
        color: theme.palette.grey[500],
    },
}))

const LibraryDialog = (props) => {
    const {open, onClose, shadow, onCommitNormativeArticle} = props

    const classes = useStyles()

    const {selectedProject, loading: projectLoading} = useSelector(getProjects)
    const libraryLoading = useSelector(selectLoading)

    const searchDialog = useDialog()

    const handleCommitArticle = (params) => {
        onCommitNormativeArticle(params)
        onClose()
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth maxWidth={'md'}
            scroll={'paper'}
            classes={
                {
                    root: !shadow ? classes.dialogRoot : undefined
                }
            }
        >
            <DialogTitle>
                <Grid container justifyContent={'space-between'} alignItems={'center'}>
                    <Grid item container spacing={2} xs alignItems={'center'}>
                        <Grid item >
                            <Typography className={classes.header} variant={'h5'}>Выбор пункта</Typography>
                        </Grid>
                        <Grid item>
                            <IconButton onClick={searchDialog.handleOpen}><SearchIcon/></IconButton>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} ><CloseIcon/></IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Backdrop className={classes.backdrop} open={Boolean(libraryLoading || projectLoading)}>
                    <CircularProgress color={'primary'}/>
                </Backdrop>
                <LibraryContainer
                    projectID={selectedProject?.id}
                    shadow={shadow}
                    loading={libraryLoading || projectLoading}
                    searchDialogOpen={searchDialog.open}
                    onSearchDialogClose={searchDialog.handleClose}
                    onCommitNormativeArticle={handleCommitArticle}
                />
            </DialogContent>
        </Dialog>
    );
};

export default LibraryDialog;